export const checkLocale = (searchParams: URLSearchParams, languages: readonly string[]) => {
  return languages.includes(`${searchParams.get("locale")}`) ? searchParams.get("locale") : "en";
};
